export function returnImageArray(file, category) {
    let newArr = []
    file.keys().forEach(url => {
        newArr.push({
            url: file(url),
            category
        });
    })
    return newArr;
}